export enum RequestFormMarkedAction {
  add = 'ADDED',
  delete = 'DELETED',
  update = 'UPDATED',
};
